
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clm/contract-lifecycle",
      function () {
        return require("private-next-pages/clm/contract-lifecycle/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clm/contract-lifecycle"])
      });
    }
  